import { jsx as _jsx } from "react/jsx-runtime";
import { sourceKeys } from 'ui-addon-upgrades/_core/common/data/upgradeData/properties/sources';
import ProductActivationButton from '../_core/productActivation/ProductActivationButton';
import { getSource } from 'ui-addon-upgrades/_core/common/data/upgradeData/transformers/getPropertySource';
import validateUpgradeData from 'ui-addon-upgrades/_core/common/data/upgradeData/validateUpgradeData';
import { MARKETING_STARTER, MARKETING_STARTER_EMAIL, GENERAL } from 'self-service-api/constants/UpgradeProducts';
const {
  PRODUCT_ACTIVATION
} = sourceKeys;

const correctUpgradeData = Component => props => {
  const {
    app,
    screen,
    uniqueId,
    upgradeProduct
  } = props.upgradeData;
  const isValid = validateUpgradeData(props.upgradeData);
  const correctedUpgradeProduct = isValid ? upgradeProduct === MARKETING_STARTER ? MARKETING_STARTER_EMAIL : upgradeProduct : GENERAL;
  const correctedUpgradeData = Object.assign({}, props.upgradeData, {
    upgradeProduct: correctedUpgradeProduct,
    source: getSource({
      app,
      screen,
      uniqueId
    }, PRODUCT_ACTIVATION)
  });
  const correctedProps = Object.assign({}, props, {
    upgradeData: correctedUpgradeData
  });
  return Component && /*#__PURE__*/_jsx(Component, Object.assign({}, correctedProps));
};

export default correctUpgradeData(ProductActivationButton);